import { jwtDecode } from 'jwt-decode';
import AppConfig from '../AppConfig';
import Cookies from 'js-cookie';
import { COOKIE_CONFIG } from '../constants';

export type JWTPayload = {
  exp?: number;
  memberId: string;
  organisationId: string;
  emailId: string;
  source: 'MEMBERS';
};

function isTokenExpired(jwtPayload: JWTPayload): boolean {
  const now = Date.now() / 1000; // current time in seconds
  return !!(jwtPayload.exp && jwtPayload.exp < now);
}

function decodeAuthToken(
  token: string = Cookies.get(AppConfig.JWT_TOKEN_COOKIE_NAME) as string
): JWTPayload | null {
  if (token) {
    const decoded = jwtDecode<JWTPayload>(token);
    if (decoded && !isTokenExpired(decoded)) {
      return decoded;
    }
    return null;
  }
  return null;
}

function verifyTokenAndInit(token: string) {
  Cookies.remove(AppConfig.JWT_TOKEN_COOKIE_NAME, { domain: 'chat.plumhq.com' }); 
  const isTokenValid = decodeAuthToken(token);
  if (isTokenValid) {
    Cookies.set(AppConfig.JWT_TOKEN_COOKIE_NAME, token, COOKIE_CONFIG);
    window.dispatchEvent(
      new Event(AppConfig.TOKEN_ADDED_VIA_EXTERNAL_APPLICATION_EVENT as string)
    );
  } else {
    window.dev.i('INVALID TOKEN:', { token });
  }
}

function getUserInfo(): JWTPayload | null {
  const parsedToken = getToken();
  if (!parsedToken) {
    return null;
  }
  return decodeAuthToken(parsedToken);
}

function getToken(): string | null {
  const token = Cookies.get(AppConfig.JWT_TOKEN_COOKIE_NAME);
  if (!token) {
    return null;
  }
  return token;
}

export {
  getUserInfo,
  getToken,
  decodeAuthToken,
  isTokenExpired,
  verifyTokenAndInit,
};